 // !! DO NOT EDIT THIS FILE DIRECTLY !!
 // !! It will be overrideen by gulp !!
 //    Please use global/scripts.js

"use strict";

/**
* @file cookie.js
* Generic cookie handling functions.
* @author Hal Burgiss 2009-03-22
*/
function setCookie(name, value, days) {
     if (days) {
          var date = new Date();
          date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
          var expires = "; expires=" + date.toGMTString();
     } else var expires = "";
     document.cookie = name + "=" + value + expires + "; path=/";
}
function readCookie(name) {
     var nameEQ = name + "=";
     var ca = document.cookie.split(';');
     for (var i = 0; i < ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) == ' ') {
               c = c.substring(1, c.length);
          }if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
     }
     return null;
}
function eraseCookie(name) {
     setCookie(name, "", -1);
}
 // !! DO NOT EDIT THIS FILE DIRECTLY !!
 // !! It will be overrideen by gulp !!
 //    Please use global/scripts.js

'use strict';

/**
 * Slate Mobile Navigation Menu
 *
 */
(function () {

	'use strict';

	/**
  * 'is_mobile' variable to determine if this is a mobile size.
  */

	var set_is_mobile,
	    is_mobile = false;

	window.addEventListener('load', function () {
		var menuToggle = document.getElementById('menu-toggle');

		(set_is_mobile = function set_is_mobile() {
			if (window.getComputedStyle(menuToggle).display === "none") {
				is_mobile = false;
			} else {
				is_mobile = true;
			}
		})();

		/**
   * Toggle menu open/closed when clicking menu toggle
   */
		menuToggle.addEventListener('click', function () {
			this.classList.toggle('open');
			document.getElementById('menu').classList.toggle('open');
			document.querySelector('body').classList.toggle('opened-menu');

			if (this.classList.contains('open')) {
				this.setAttribute('aria-expanded', true);
			} else {
				this.setAttribute('aria-expanded', false);
			}
		});
	});

	var subToggles = document.querySelectorAll('.submenu-toggle');

	for (var i = 0; subToggles.length > i; i++) {
		var focus_out_timer = null;
		var toggle_button = subToggles[i];

		toggle_button.addEventListener('click', function () {
			this.classList.toggle('open');
			this.parentNode.classList.toggle('open');

			if (this.classList.contains('open')) {
				this.setAttribute('aria-expanded', true);
			} else {
				this.setAttribute('aria-expanded', false);
			}
		});
	}
})();
 // !! DO NOT EDIT THIS FILE DIRECTLY !!
 // !! It will be overrideen by gulp !!
 //    Please use global/scripts.js

'use strict';

/**
* This file is loaded asyncronously in the footer.
* All custom global scripts should be included here.
*/

/*
A little info for this js file:
	As much as possible, this file should be kept organized. Currently, two major divisions are seen below, delinitated by their respective functions of "on load" and "ready".
	As mentioned below, most code added to this file should be included within the "on load" function.
	For ease of future use, include any new code at the bottom of the relevant section of the page, adding clear comments to explain the purpose of the code being written,
	including any relavant details regarding what the code overrides, etc.
*/

(function () {
    'use strict';

    // rerun lazyload on screen size updates

    window.addEventListener('resize', function () {
        dbs.lazyload();
    });

    // Load event function ... most custom stuff goes here. Safer for async.
    window.addEventListener('load', function () {
        /* Search Form functionality
         * The click functionality involves three different actions,
         * depending on conditions the various clicks provide.
         */
        var searchOpen = document.querySelectorAll('.search-form__button--open');
        var searchClose = document.querySelectorAll('.search-form__button--close');

        if (searchOpen) {
            for (var i = 0; searchOpen.length > i; i++) {
                searchOpen[i].addEventListener('click', function () {
                    this.parentElement.classList.add('search-form--active');
                    this.parentElement.querySelector('.site_search__field').focus();

                    // Hide the search bar after click out of it
                    document.getElementById('content').addEventListener('click', function () {
                        if (this.parentElement.classList.contains('search-form--active')) {
                            this.parentElement.classList.remove('search-form--active');
                        }
                    });
                });
            }

            for (var i = 0; searchClose.length > i; i++) {
                searchClose[i].addEventListener('click', function () {
                    this.parentElement.classList.remove('search-form--active');
                });
            }
        }

        /**
         * Linkclicker
         * 
         * A class placed on a wrapping element with a link inside to make the wrapper clickable.
         * Note: the container should have only one link.
         */
        var linkclickers = document.querySelectorAll('.linkclicker');

        for (var i = 0; linkclickers.length > i; i++) {
            var linkclicker = linkclickers[i];

            linkclicker.addEventListener('click', function (e) {
                e.preventDefault();
                var link = this.querySelector('a');
                var linkPath = link.getAttribute('href');

                if (link.getAttribute('target', "_blank")) {
                    window.open(linkPath);
                } else {
                    window.location.href = linkPath;
                }
            });
        }

        /**
         * Force external links/PDFs to open in a new tab.
         * From https://stackoverflow.com/questions/2910946/test-if-links-are-external-with-jquery-javascript
         * 2019-07-11 - TA
         */
        function link_is_external(link_element) {
            return link_element.host !== window.location.host || link_element.href.indexOf("pdf") > -1;
        }

        var anchorElements = document.getElementsByTagName('a');
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = anchorElements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var anchorElement = _step.value;


                if (link_is_external(anchorElement)) {
                    anchorElement.setAttribute('target', '_blank');
                    anchorElement.setAttribute('rel', 'noopener');

                    // Add assistive text to alert of external links
                    var assistiveText = '<span class="assistive">. External Link. Opens in new window.</span>';
                    var assistiveTextContainer = document.createElement('span');
                    assistiveTextContainer.innerHTML = assistiveText;
                    anchorElement.appendChild(assistiveTextContainer.firstChild);
                }
            }

            /**
            * Captures Google Analytics Client ID and inputs into hidden form field
            */
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }

        var g_id = document.querySelector('.g-id input');

        function fillClientId() {
            // Capture Client ID
            var clientId = document.cookie.match(/_ga=(.+?);/)[1].split('.').slice(-2).join(".");
            // Populate hidden form field with Client ID
            g_id.value = clientId;
        }

        // On pages with client ID form field and analytics is loaded, populate
        if (g_id && Object.keys(window.google_tag_manager || []).filter(function (e) {
            return e.substring(0, 2) == 'G-';
        }).length > 0) {
            // Give GTM time to load
            setTimeout(function () {
                fillClientId();
            }, 5000);
        }

        /*
         * Detects if element is in viewport and add class
         */

        /**
               * Add class when the element's TOP is at least 20% from the bottom of the viewport.
               * (i.e., when el.getBoundingClientRect().top <= 0.8 * viewportHeight)
               */
        function observeElements(elements, className) {
            var observer = new IntersectionObserver(function (entries) {
                var vh = window.innerHeight || document.documentElement.clientHeight;

                entries.forEach(function (entry) {
                    // Only consider elements within the viewport region (cheap guard)
                    if (!entry.isIntersecting) return;

                    var top = entry.target.getBoundingClientRect().top;

                    if (top <= vh * 0.8) {
                        entry.target.classList.add(className);
                        observer.unobserve(entry.target); // optional: fire once
                    }
                    // else: still intersecting but top hasn't reached the 80% line yet.
                    // Keep observing; the callback will fire again as it scrolls.
                });
            }, {
                root: null,
                // Trim the bottom 20% so we don't even get called until we're above that line.
                // (Helps reduce callback spam, but the top check above is the authoritative test.)
                rootMargin: '0px 0px -20% 0px',
                threshold: 0 // fire as soon as any pixel intersects the allowed area
            });

            elements.forEach(function (el) {
                return observer.observe(el);
            });
        }

        // Usage
        var elements = document.querySelectorAll('.animated');
        observeElements(elements, 'in-view');

        /**
                * Collapsibles
                */
        var collapsibleHeaders = document.querySelectorAll(".collapsible-row__header");

        if (collapsibleHeaders) {
            for (var i = 0; collapsibleHeaders.length > i; i++) {
                var collapsibleHeader = collapsibleHeaders[i];

                collapsibleHeader.addEventListener("click", function () {
                    this.classList.toggle("expanded");
                    var textHeight = this.parentElement.nextElementSibling.querySelector(".collapsible-row__content").clientHeight; // Get height of text within collapsible row
                    var rowHeight = this.parentElement.nextElementSibling.clientHeight; // Get height of row to see if it's expanded

                    if (rowHeight == 0) {
                        // If collapsible content is collapsed...
                        this.parentElement.nextElementSibling.style.height = textHeight + 1 + "px";
                    } else {
                        this.parentElement.nextElementSibling.style.height = 0 + "px";
                    }

                    if (this.parentNode.parentNode.classList.contains("expanded")) {
                        this.setAttribute("aria-expanded", "true");
                    } else {
                        this.setAttribute("aria-expanded", "false");
                    }
                });

                collapsibleHeader.parentElement.nextElementSibling.style.height = 0 + "px";
                collapsibleHeader.setAttribute("aria-expanded", "false");
            }
        }

        // Ensure Flickity has rendered
        var flickities = Flickity.data(document.querySelectorAll('.flickity-enabled'));
        if (flickities && flickities.length > 0) {
            flickities.forEach(function (flkty) {
                return flkty.resize();
            });
        }

        // Re-run scroll if there’s a hash
        if (window.location.hash) {
            var target = document.querySelector(window.location.hash);
            if (target) {
                var headerOffset = 96;
                var elementPosition = target.getBoundingClientRect().top + window.scrollY;
                var offsetPosition = elementPosition - headerOffset;
                window.scrollTo({ top: offsetPosition });
            }
        }
    }); // End of load function


    // Include ready events here
    window.addEventListener('DOMContentLoaded', function () {});

    document.addEventListener('click', function (e) {
        var link = e.target.closest('a[href^="#"]');
        if (!link) return;

        var targetId = link.getAttribute('href');
        if (targetId.length <= 1) return; // ignore empty hashes or "#"

        var target = document.querySelector(targetId);
        if (!target) return;

        e.preventDefault();

        var headerOffset = 96; // example: 6rem if root font-size = 16px
        var elementPosition = target.getBoundingClientRect().top + window.scrollY;
        var offsetPosition = elementPosition - headerOffset;

        window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
        });
    });

    function onReady(fn) {
        if (document.readyState !== 'loading') {
            fn();
        } else {
            document.addEventListener('DOMContentLoaded', fn);
        }
    }

    onReady(function () {
        var lastScrollY = window.scrollY;
        var ticking = false;
        var header = document.querySelector('.site-header');
        var headerHeight = header.offsetHeight;
        var hiddenOffset = 0; // how much of the header is currently hidden (0 = fully visible)

        function updateHeader() {
            var currentScrollY = window.scrollY;
            var delta = currentScrollY - lastScrollY;

            // Scrolling down → hide progressively
            if (delta > 0) {
                hiddenOffset = Math.min(hiddenOffset + delta, headerHeight);
            }
            // Scrolling up → reveal progressively
            else if (delta < 0) {
                    hiddenOffset = Math.max(hiddenOffset + delta, 0);
                }

            // Apply transform to slide header based on hidden offset
            header.style.transform = 'translateY(-' + hiddenOffset + 'px)';

            // Add/remove 'sticky' class based on scroll direction, position, and screen width
            var isDesktop = window.innerWidth >= 992;
            if (delta < 0 && currentScrollY > 0 && isDesktop) {
                header.classList.add('sticky');
            } else {
                header.classList.remove('sticky');
            }

            lastScrollY = currentScrollY;
            ticking = false;
        }

        window.addEventListener('scroll', function () {
            if (!ticking) {
                window.requestAnimationFrame(updateHeader);
                ticking = true;
            }
        });

        // Also remove the class if resizing below desktop width
        window.addEventListener('resize', function () {
            var header = document.querySelector('.site-header');
            if (header && window.innerWidth < 992) {
                header.classList.remove('sticky');
            }
        });
    });
})();